import { createUserWithEmailAndPassword, getAuth } from "firebase/auth";
import { ref, set, getDatabase } from "firebase/database";
import React, { useState } from "react";
import { Navigate } from "react-router";

import {
  Button,
  Form,
  FormFeedback,
  FormGroup,
  FormText,
  Input,
  Label,
} from "reactstrap";
import ErrorMessage from "./ErrorMessage";

export default function Register(props) {
  const [userInfo, setUserInfo] = useState({
    first: "",
    last: "",
    password: "",
    email: "",
    calendly: "",
    image: "",
    banner: "",
    space: {
      title: "",
      description: "",
      space_link: "",
      price: "",
    },
  });
  const [errorMessage, setErrorMessage] = useState("");
  const [redirect, setRedirect] = useState(null);

  let [valid, setValid] = useState({});

  const validatePassword = (e) => {
    let status = "";
    if (e.target.value.length < 6) {
      status = "invalid";
    } else {
      status = "valid";
    }

    valid[e.target.id] = status;
    setValid(valid);
  };

  const validateCalendly = (e) => {
    let status = "";
    if (
      e.target.value.length === 0 ||
      !e.target.value.includes("https://") ||
      !e.target.value.includes("calendly.com")
    ) {
      status = "invalid";
    } else {
      status = "valid";
    }

    valid[e.target.id] = status;
    setValid(valid);
  };

  const validateEmail = (e) => {
    let status = "";
    if (
      e.target.value.length === 0 ||
      !e.target.value.includes("@") ||
      !e.target.value.includes(".")
    ) {
      status = "invalid";
    } else {
      status = "valid";
    }

    valid[e.target.id] = status;
    setValid(valid);
  };

  const updateUser = (e) => {
    const newUser = { ...userInfo };
    newUser[e.target.id] = e.target.value;
    setUserInfo(newUser);
  };

  const submitForm = (e) => {
    e.preventDefault();
    if (!checkDisabled()) {
      setErrorMessage("Enter in valid values before submitting!");
    } else {
      const auth = getAuth();
      createUserWithEmailAndPassword(auth, userInfo.email, userInfo.password)
        .then((userCredential) => {
          // Registered
          let user = userCredential.user;
          // Enter the user's data into the Firebase Realtime Database
          set(ref(getDatabase(), "users/" + user.uid), {
            first_name: userInfo["first-name"],
            last_name: userInfo["last-name"],
            email: userInfo.email,
            calendly: userInfo.calendly,
            about_me: userInfo.about_me,
            pfp_link: userInfo.image,
            banner_link: "",
            space: {
              title: userInfo.title,
              thumbs: 0,
              description: userInfo.description,
              image: userInfo.space_link,
              price: parseInt(userInfo.price),
            },
          });
          props.callback(user.uid); // Set the state variable in <App> for the user's (newly created) UID
          setRedirect(user.uid);
        })
        .catch((error) => {
          setErrorMessage(error.message);
        });
    }
    // if (error)
  };

  const validateNonEmpty = (e) => {
    let status = "";
    if (e.target.value.length === 0) {
      status = "invalid";
    } else {
      status = "valid";
    }

    valid[e.target.id] = status;

    setValid(valid);
  };

  const checkDisabled = () => {
    if (Object.keys(valid).length !== 11) {
      return false;
    } else {
      for (const property in valid) {
        if (valid[property] !== "valid") {
          return false;
        }
      }
      return true;
    }
  };
  return (
    <main>
      {redirect ? <Navigate to={`/profile/${redirect}`} /> : null}
      <div className="container">
        <div className="card">
          <div className="card-body">
            <h1 className="card-title text-center">Register as a host</h1>
            <Form onSubmit={submitForm} noValidate>
              <ErrorMessage errorMessage={errorMessage} />
              <FormGroup>
                <Label>First Name</Label>
                <Input
                  aria-label="First Name"
                  type="text"
                  name="first-name"
                  id="first-name"
                  placeholder="John"
                  valid={valid["first-name"] === "valid"}
                  invalid={valid["first-name"] === "invalid"}
                  onChange={(e) => {
                    validateNonEmpty(e);
                    updateUser(e);
                  }}
                />
                <FormFeedback invalid={(valid["first-name"] === "invalid").toString()}>First name cannot be empty!</FormFeedback>
              </FormGroup>
              <FormGroup>
                <Label>Last Name</Label>
                <Input
                  aria-label="Last Name"
                  type="text"
                  name="last-name"
                  id="last-name"
                  placeholder="Doe"
                  valid={valid["last-name"] === "valid"}
                  invalid={valid["last-name"] === "invalid"}
                  onChange={(e) => {
                    validateNonEmpty(e);
                    updateUser(e);
                  }}
                />
                <FormFeedback invalid={(valid["last-name"] === "invalid").toString()}>Last name cannot be empty!</FormFeedback>
              </FormGroup>
              <FormGroup>
                <Label>Email</Label>
                <Input
                  aria-label="Your email address"
                  type="text"
                  name="email"
                  id="email"
                  valid={valid["email"] === "valid"}
                  invalid={valid["email"] === "invalid"}
                  placeholder="your-email@example.com"
                  onChange={(e) => {
                    validateEmail(e);
                    updateUser(e);
                  }}
                />
                <FormFeedback invalid={(valid["email"] === "invalid").toString()}>Please enter a valid email!</FormFeedback>
              </FormGroup>
              <FormGroup>
                <Label>Profile Picture Link</Label>
                <Input
                  aria-label="Profile Picture Link"
                  type="text"
                  name="image"
                  id="image"
                  valid={valid["image"] === "valid"}
                  invalid={valid["image"] === "invalid"}
                  onChange={(e) => {
                    validateNonEmpty(e);
                    updateUser(e);
                  }}
                />
                <FormFeedback invalid={(valid["image"] === "invalid").toString()}>Link cannot be empty!</FormFeedback>
              </FormGroup>
              <FormGroup>
                <Label>Password</Label>
                <Input
                  aria-label="Password"
                  type="password"
                  name="password"
                  id="password"
                  valid={valid["password"] === "valid"}
                  invalid={valid["password"] === "invalid"}
                  onChange={(e) => {
                    validatePassword(e);
                    updateUser(e);
                  }}
                />
                <FormFeedback invalid={(valid["password"] === "invalid").toString()}>
                  Password cannot be less than 6 characters!
                </FormFeedback>
                <FormText>Passwords should be at least 6 characters.</FormText>
              </FormGroup>
              <FormGroup>
                <Label>About Me</Label>
                <Input
                  aria-label="About Me"
                  type="text"
                  name="about_me"
                  id="about_me"
                  valid={valid["about_me"] === "valid"}
                  invalid={valid["about_me"] === "invalid"}
                  onChange={(e) => {
                    validateNonEmpty(e);
                    updateUser(e);
                  }}
                />
                <FormFeedback invalid={(valid["about_me"] === "invalid").toString()}>About me cannot be empty!</FormFeedback>
              </FormGroup>
              <FormGroup>
                <Label>Title of Your Space</Label>
                <Input
                  aria-label="Title of Your Space"
                  type="text"
                  name="title"
                  id="title"
                  valid={valid["title"] === "valid"}
                  invalid={valid["title"] === "invalid"}
                  onChange={(e) => {
                    validateNonEmpty(e);
                    updateUser(e);
                  }}
                />
                <FormFeedback invalid={(valid["title"] === "invalid").toString()}>Title cannot be empty!</FormFeedback>
              </FormGroup>
              <FormGroup>
                <Label>Description of Your Space</Label>
                <Input
                  aria-label="Description of Your Space"
                  type="text"
                  name="description"
                  id="description"
                  valid={valid["description"] === "valid"}
                  invalid={valid["description"] === "invalid"}
                  onChange={(e) => {
                    validateNonEmpty(e);
                    updateUser(e);
                  }}
                />
                <FormFeedback invalid={(valid["description"] === "invalid").toString()}>
                  Description cannot be empty!
                </FormFeedback>
              </FormGroup>
              <FormGroup>
                <Label>Price of Hourly Rental</Label>
                <Input
                  aria-label="Price of Daily Rental in USD"
                  type="number"
                  name="price"
                  id="price"
                  valid={valid["price"] === "valid"}
                  invalid={valid["price"] === "invalid"}
                  onChange={(e) => {
                    validateNonEmpty(e);
                    updateUser(e);
                  }}
                />
                <FormFeedback invalid={(valid["price"] === "invalid").toString()}>
                  Price cannot be empty!
                </FormFeedback>
              </FormGroup>
              <FormGroup>
                <Label>Link to Image of Your Space</Label>
                <Input
                  aria-label="Link to Image of Your Space"
                  type="text"
                  name="space_link"
                  id="space_link"
                  valid={valid["space_link"] === "valid"}
                  invalid={valid["space_link"] === "invalid"}
                  onChange={(e) => {
                    validateNonEmpty(e);
                    updateUser(e);
                  }}
                />
                <FormFeedback invalid={(valid["space_link"] === "invalid").toString()}>
                  Link to space's image cannot be empty!
                </FormFeedback>
              </FormGroup>
              <FormGroup>
                <Label>Calendly Link</Label>
                <Input
                  aria-label="Calendly Link"
                  type="text"
                  name="calendly"
                  id="calendly"
                  valid={valid.calendly === "valid"}
                  invalid={(valid.calendly === "invalid")}
                  onChange={(e) => {
                    validateNonEmpty(e);
                    validateCalendly(e);
                    updateUser(e);
                  }}
                />
                <FormFeedback invalid>Link isn't a valid calendly link!</FormFeedback>
                <FormText>
                  We use Calendly to allow users to rent your space. Please make
                  an account on{" "}
                  <a
                    rel="noreferrer"
                    href="https://calendly.com/"
                    target="_blank"
                  >
                    calendly.com
                  </a>{" "}
                  and add your personal link here.
                </FormText>
              </FormGroup>
              <Button>Submit</Button>
            </Form>
          </div>
        </div>
      </div>
    </main>
  );
}
